export const EDITOR_LAYOUTS_DISPLAY_MODAL_SUCCESS =
  "API/UI/EDITOR_LAYOUTS/DISPLAY_MODAL_SUCCESS";

export const EDITOR_LAYOUTS_FETCH_DATA_REQUEST =
  "API/UI/EDITOR_LAYOUTS/FETCH_DATA_REQUEST";
export const EDITOR_LAYOUTS_FETCH_DATA_SUCCESS =
  "API/UI/EDITOR_LAYOUTS/FETCH_DATA_SUCCESS";
export const EDITOR_LAYOUTS_FETCH_DATA_FAILURE =
  "API/UI/EDITOR_LAYOUTS/FETCH_DATA_FAILURE";
